import Lang from 'lang.js'

global.Lang = Lang

export const lang = new Lang({locale: document.querySelector('html').lang, fallback: 'fr', messages: require('./locales.json')})
export const trans = (key, params) => {
  return lang.get(key, params)
}
export const choice = (key, count, params) => {
  return lang.choice(key, count, params)
}

window.lang = lang
window.trans = trans
window.choice = choice

let VueLangTrans = function () {
}

VueLangTrans.install = function (Vue) {
  Vue.lang = lang
  Vue.trans = trans
  Vue.choice = choice

  Object.defineProperty(Vue.prototype, '$lang', {
    get: function get() {
      return lang
    }
  })
  Object.defineProperty(Vue.prototype, '$trans', {
    get: function get() {
      return trans
    }
  })
  Object.defineProperty(Vue.prototype, '$choice', {
    get: function get() {
      return choice
    }
  })
}
global.VueLangTrans = VueLangTrans
